import React from "react";
import styled from "styled-components";

interface PlaceholderLogoProps {
  name: string;
  width?: number;
  height?: number;
}

const LogoContainer = styled.div<{ width: number; height: number }>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #666;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
`;

const PlaceholderLogo: React.FC<PlaceholderLogoProps> = ({
  name,
  width = 120,
  height = 40,
}) => {
  return (
    <LogoContainer width={width} height={height}>
      {name}
    </LogoContainer>
  );
};

export default PlaceholderLogo; 